import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconFullMoon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFullMoon"><Circle cx="12.5" cy="7.5" r="0.75" fill="currentColor" stroke="currentColor" strokeWidth="1.5"/><Circle cx="8.1" cy="9.6" r="1.1" fill="currentColor"/><Circle cx="10" cy="15" r="2" stroke="currentColor" strokeWidth="1.5"/><Path d="M20.5 9.03076C18.5268 9.27681 17 10.96 17 12.9998C17 14.7686 18.1481 16.2693 19.7397 16.7972" stroke="currentColor" strokeWidth="1.5"/><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconFullMoon;
